export default "__VITE_ASSET__021a3058__"